// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3E4pd","label":"Radio_label__2oCz-","checkMark":"Radio_checkMark__Y6Znm","disabled":"Radio_disabled__26R0N"};